import React, { useState, useEffect } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
  BtnDisabled,
} from '../../styled-components';
import { Row, Col, Label, FormText } from 'reactstrap/lib';
import DateInput from '../../commons/DateInput';
import AutoSuggest from '../../commons/Autosuggest';
import axios from 'axios';
import { useAlert } from 'react-alert';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import ManageCondoButton from './ManageCondoButton';
import { useLoading } from '../../commons/Loading';

const INITIAL_ADMIN = { _id: '', businessName: '' };

function ActionsField(props) {
  const {
    data,
    onChangeAdmin,
    onExtendAdminManagement,
    profile,
    onCondoUpdate,
    truncateTable,
    checkVatCode,
    condoId,
  } = props;

  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CONDOS');
  const [changeAdminModal, setChangeAdminModal] = useState(false);
  const [changeModal, setAdminModal] = useState(false);
  const { showLoading, hideLoading } = useLoading();

  const [admin, setAdmin] = useState(INITIAL_ADMIN);
  const [sameAdminError, setSameAdminError] = useState(false);
  const [emptyAdminError, setEmptyAdminError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [extraInvoiceDateError, setExtraInvoiceDateError] = useState(false);
  const [endDatePreviusAdminError, setEndDatePreviusAdminError] = useState(
    false
  );
  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDateError, setEndDateError] = useState(false);
  const [datesError, setDatesError] = useState(false);
  const [extraInvoiceDate, setExtraInvoiceDate] = useState(null);
  const [datesEndChangeAdminError, setDatesEndChangeAdminError] = useState(
    false
  );
  const [datesStartChangeAdminError, setDatesStartChangeAdminError] = useState(
    false
  );

  const searchExtraInvoiceBiggerDate = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/condos/extra-invoice-date/${data._id}`,
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data: dataResponse = [] } = response;
    if (dataResponse.endOfMonth) {
      setExtraInvoiceDate(
        moment(dataResponse.endOfMonth).startOf('day').toDate()
      );
    }
  };

  const toggleChangeAdminModal = () => {
    setDatesError(false);
    setEmptyAdminError(false);
    setDatesEndChangeAdminError(false);
    setDatesStartChangeAdminError(false);
    setSameAdminError(false);
    setExtraInvoiceDateError(false);
    setEndDatePreviusAdminError(false);
    setChangeAdminModal(!changeAdminModal);

    if (
      moment(startDate)
        .startOf('day')
        .isAfter(moment(data.balance?.endDate).startOf('day'))
    ) {
      setEndDatePreviusAdminError(true);
    }

    if (!changeAdminModal) {
      searchExtraInvoiceBiggerDate();
    }
  };

  const toggleChangeModal = () => {
    setEndDateError(false);
    setDatesError(false);
    setAdminModal(!changeModal);
  };

  const searchAdministrators = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/admins`,
      {
        headers: { Authorization: newToken },
        params: { search: value },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;

    return data;
  };

  const renderAdminSuggestion = ({ businessName = '' }) => businessName;
  const getAdminSuggestionValue = ({ businessName = '' }) => businessName;

  function onAdminSuggestionSelect({ _id, businessName }) {
    setAdmin({ _id: _id, businessName: businessName });
  }

  function onChangeAdminConfirm() {
    setDatesStartChangeAdminError(false);
    setDatesEndChangeAdminError(false);
    setEmptyAdminError(false);
    setSameAdminError(false);
    setStartDateError(false);
    setExtraInvoiceDateError(false);

    if (
      moment(startDate)
        .startOf('day')
        .isBefore(moment(data.currentAdmin?.endDate).startOf('day'))
    ) {
      setDatesStartChangeAdminError(true);
      return;
    }
    if (
      moment(startDate).startOf('day').isAfter(moment(endDate).startOf('day'))
    ) {
      setDatesEndChangeAdminError(true);
      return;
    }

    if (
      moment(startDate)
        .startOf('day')
        .isBefore(moment(data.currentAdmin?.endDate).startOf('day'))
    ) {
      setStartDateError(true);
      return;
    }

    if (
      extraInvoiceDate &&
      moment(startDate)
        .startOf('day')
        .isSameOrBefore(moment(extraInvoiceDate).startOf('day'))
    ) {
      setExtraInvoiceDateError(true);
      return;
    }

    if (admin._id === '') {
      setEmptyAdminError(true);
      return;
    }
    if (!sameAdminError) {
      onChangeAdmin({
        id: data._id,
        admin: admin._id,
        endDate: endDate,
        startDate: startDate,
      });
      toggleChangeAdminModal();
    }
  }

  function onChangeConfirm() {
    if (!endDate) setEndDateError(true);
    else if (moment(data.currentAdmin?.startDate).isAfter(endDate))
      setDatesError(true);
    else {
      onExtendAdminManagement({ id: data._id, endDate: endDate });
      toggleChangeModal();
      setAdmin(INITIAL_ADMIN);
    }
  }

  useEffect(() => {
    if (admin._id === data.currentAdmin?._id) {
      setSameAdminError(true);
    } else setSameAdminError(false);

    if (data.currentAdmin?.endDate) {
      setEndDate(moment(data.balance?.endDate).startOf('day'));
      setStartDate(
        moment(data.currentAdmin?.endDate).startOf('day').add(1, 'day')
      );
    }
  }, [data]);

  const history = useHistory();

  return (
    <React.Fragment>
      <div className="flex-check">
        <ManageCondoButton condo={data} onConfirm={onCondoUpdate} />

        {!truncateTable &&
        moment(data.currentAdmin?.startDate)
          .startOf('day')
          .isSameOrBefore(moment.utc().startOf('day')) ? (
          <BtnModalTable
            type="button"
            className="mx-2 px-2"
            onClick={(event) => {
              event.stopPropagation();
              toggleChangeAdminModal();
            }}
          >
            {t('CHANGE_ADMIN')}
          </BtnModalTable>
        ) : newIsAdmin ? (
          <BtnDisabled type="button" className="mx-2 px-2" disabled>
            {t('CHANGE_ADMIN')}
          </BtnDisabled>
        ) : (
          <></>
        )}

        <BtnModalTable
          type="button"
          className="mx-2 px-2"
          onClick={(event) => {
            event.stopPropagation();
            history.push(`/my-condos/${data._id}`);
          }}
        >
          {t('INFO_CONDO')}
        </BtnModalTable>
      </div>

      <Modal
        isOpen={changeAdminModal}
        toggle={toggleChangeAdminModal}
        className="new-condo-modal"
      >
        <ModalHeader toggle={toggleChangeAdminModal}>
          {t('CHANGE_ADMIN')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onChangeAdminConfirm();
          }}
        >
          <ModalBody>
            <FormGroup>
              <Label>{t('NEW_ADMIN')}</Label>
              <AutoSuggest
                placeholder="Cerca un amministratore..."
                onFetch={searchAdministrators}
                onSelect={onAdminSuggestionSelect}
                renderSuggestion={renderAdminSuggestion}
                getSuggestionValue={getAdminSuggestionValue}
                value={admin?.businessName}
                onChange={(businessName) =>
                  setAdmin({ ...admin, businessName: businessName })
                }
              />
              {sameAdminError && (
                <FormText className="error-message">
                  {t('SAME_ADMIN_ERROR')}
                </FormText>
              )}
              {emptyAdminError && (
                <FormText className="error-message">
                  {t('COMMON:REQUIRED')}
                </FormText>
              )}
            </FormGroup>
            <Row>
              <Col sm="12">
                <p className="text-bold mb-2">{t('BALANCE_PERIOD')}:</p>
              </Col>
              <Col xs="12" md="6" lg="6">
                <FormGroup>
                  <Label>{t('BALANCE_START_DATE')}</Label>
                  <DateInput
                    name="balanceStartDate"
                    value={data.balance?.startDate}
                    disabled={true}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" md="6" lg="6">
                <FormGroup>
                  <Label>{t('BALANCE_END_DATE')}</Label>
                  <DateInput
                    name="balanceEndDate"
                    value={data.balance?.endDate}
                    disabled={true}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">
                    <p className="text-bold mb-2">{t('MANAGEMENT_PERIOD')}:</p>
                  </Col>
                  <Col xs="12" md="6" lg="6">
                    <FormGroup>
                      <Label>{t('START_DATE')}</Label>
                      <DateInput
                        name="startDate"
                        value={startDate}
                        disabled={moment(startDate)
                          .startOf('day')
                          .isAfter(moment(endDate).startOf('day'))}
                        onChange={setStartDate}
                      />
                      {datesStartChangeAdminError && (
                        <FormText className="error-message">
                          {t('DATES_START_ERROR')}
                        </FormText>
                      )}
                      {startDateError && (
                        <FormText className="error-message">
                          {t('START_DATE_ERROR')}
                        </FormText>
                      )}
                      {extraInvoiceDateError && (
                        <FormText className="error-message">
                          {t('START_DATE_EXCEDE_MAX_DATE_ERROR')}
                        </FormText>
                      )}
                      {endDatePreviusAdminError && (
                        <FormText className="error-message">
                          {t('PREVIOUS_ADMIN_END_DATE_ERROR')}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                  <Col xs="12" md="6" lg="6">
                    <FormGroup>
                      <Label>{t('END_DATE')}</Label>
                      <DateInput
                        name="endDate"
                        value={endDate}
                        disabled={true}
                      />
                      {datesEndChangeAdminError && (
                        <FormText className="error-message">
                          {t('DATES_ERROR')}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed
              type="button"
              className="uppercase"
              onClick={toggleChangeAdminModal}
            >
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={changeModal} className="new-condo-modal">
        <ModalHeader toggle={toggleChangeModal}>{t('EXTENDS')}</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onChangeConfirm();
          }}
        >
          <ModalBody>
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">
                    <p className="text-bold mb-2">{t('MANAGEMENT_PERIOD')}:</p>
                  </Col>
                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('START_DATE')}</Label>
                      <DateInput name="startDate" value={startDate} readOnly />
                      {datesError && (
                        <FormText className="error-message">
                          {t('DATES_ERROR')}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                  <Col xs="12" md="6" lg="4">
                    <FormGroup>
                      <Label>{t('END_DATE')} *</Label>
                      <DateInput
                        name="endDate"
                        value={endDate}
                        onChange={setEndDate}
                      />
                      {endDateError && (
                        <FormText className="error-message">
                          {t('COMMON:REQUIRED')}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed
              type="button"
              className="uppercase"
              onClick={toggleChangeModal}
            >
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default ActionsField;
